import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Snackbar,
  Stack,
  Typography,
  Alert,
} from "@mui/material";
import React, { useState } from "react";
import { loginLeftContentContainerItemWidth } from "../../UI/styles/Login";
import PasswordInput from "../../UI/Input/PasswordInput";
import { settingStyles } from "../../UI/styles/Main";
import {
  useGetUserInfoQuery,
  useUpdateUserInfoMutation,
} from "../../../Api/apiSlice"

function ChangePassword() {
  const { data, error, isLoading } = useGetUserInfoQuery();
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [updateUserInfo, { isLoading: isUpdating }] = useUpdateUserInfoMutation();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleReset = () => {
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
  };

  const handleSubmit = async () => {
    if (!oldPassword || !password || !confirmPassword) {
      setSnackbar({ 
        open: true,
        message: "Please fill in all fields!",
        severity: "error",
      });
      return;
    }

    if (password.length < 8) {
      setSnackbar({
        open: true,
        message: "Password must be at least 8 characters long!",
        severity: "error",
      });
      return;
    }
    
    // alert(password)
    if (password !== confirmPassword) {
      setSnackbar({
        open: true,
        message: "Passwords do not match!",
        severity: "error",
      });
      return;
    }

    try {
      await updateUserInfo({
        oldPassword: oldPassword,
        userId: data.userInfo?.id,
        userPassword: password,
      }).unwrap();
      setSnackbar({
        open: true,
        message: "Password updated successfully!",
        severity: "success",
      });
      handleReset();
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.data?.error || "Failed to update password.",
        severity: "error",
      });
      console.error("Erro-r", error?.data?.error);
    }
  };

  return (
    <>
      <Paper sx={settingStyles.changePasswordPaper}>
        <Box sx={settingStyles.changePasswordContainer}>
          <Box
            sx={{
              paddingLeft: {
                xs: "40px",
                lg: "40px",
              },
            }}
          >
            <Box sx={loginLeftContentContainerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={4}
                mb={1}
                style={settingStyles.profileLabel}
              >
                Enter Old Password
              </Typography>
              <Box sx={settingStyles.textFieldBox}>
                <PasswordInput
                  label="Enter old Password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  disabled={isLoading || isUpdating}
                />
              </Box>
            </Box>
            <Box sx={loginLeftContentContainerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={settingStyles.profileLabel}
              >
                Password
              </Typography>
              <Box sx={settingStyles.textFieldBox}>
                <PasswordInput
                  label="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading || isUpdating}
                />
              </Box>
            </Box>
            <Box sx={loginLeftContentContainerItemWidth}>
              <Typography
                variant="subtitle1"
                mt={3}
                mb={1}
                style={settingStyles.profileLabel}
              >
                Confirm Password
              </Typography>
              <Box sx={settingStyles.textFieldBox}>
                <PasswordInput
                  label="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={isLoading || isUpdating}
                />
              </Box>
            </Box>
          </Box>

          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "24px",
              paddingLeft: {
                xs: "40px",
                lg: "40px",
              },
            }}
            mr={{ lg: 5, xs: 9 }}
            mt={{ lg: 0, xs: 2 }}
          >
            <Button
              variant="outlined"
              onClick={handleReset}
              disabled={isLoading || isUpdating}
              sx={{
                width: "185px",
                height: "53px",
                backgroundColor: "white",
                color: "#F38712",
                textTransform: "none",
                border: "1px solid #F38712",
                "&:hover": {
                  backgroundColor: "white",
                  border: "1px solid #F38712",
                },
              }}
            >
              Reset Changes
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading || isUpdating}
              sx={{
                width: "247px",
                height: "53px",
                backgroundColor: "#F38712",
                color: "white",
                textTransform: "none",
                border: "1px solid #F38712",
                "&:hover": {
                  backgroundColor: "#F38712",
                  border: "1px solid #F38712",
                },
              }}
            >
              {isLoading || isUpdating ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Update"
              )}
            </Button>
          </Stack>
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ChangePassword;
